import { render, staticRenderFns } from "./onglets.vue?vue&type=template&id=ad6d567c"
import script from "./onglets.js?vue&type=script&lang=js&external"
export * from "./onglets.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports